// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"e5dd5c1c","264":"67dc8fc3","563":"7c8c31ed","593":"439e3510","681":"b2dfa7a3","702":"0f27b82d","735":"e6cf3ed3","895":"8f9f923b"}[chunkId] + ".chunk.js";
};